/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_IllustrationInputs */

const en_mk_sol_illustration = /** @type {(inputs: Mk_Sol_IllustrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page is an **illustration**, not a case study. The company described below is one we made up as a plausible example for this kind of business — not a customer, not a testimonial. The cost figures are computed from our published plan prices.`)
};

const id_mk_sol_illustration = /** @type {(inputs: Mk_Sol_IllustrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman ini adalah **ilustrasi**, bukan studi kasus. Perusahaan yang digambarkan di bawah kami susun sendiri sebagai contoh yang masuk akal untuk jenis usaha ini — bukan pelanggan kami, bukan testimoni. Angka biayanya dihitung dari harga paket yang berlaku.`)
};

/**
* | output |
* | --- |
* | "This page is an **illustration**, not a case study. The company described below is one we made up as a plausible example for this kind of business — not a cu..." |
*
* @param {Mk_Sol_IllustrationInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_illustration = /** @type {((inputs?: Mk_Sol_IllustrationInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_IllustrationInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_illustration(inputs)
	return en_mk_sol_illustration(inputs)
});